var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoSnackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.5078 0 20 4.49219 20 10C20 15.5469 15.5078 20 10 20C4.45312 20 0 15.5469 0 10C0 4.49219 4.45312 0 10 0ZM10 18.75C14.8047 18.75 18.75 14.8438 18.75 10C18.75 5.19531 14.8047 1.25 10 1.25C5.15625 1.25 1.25 5.19531 1.25 10C1.25 14.8438 5.15625 18.75 10 18.75ZM10 7.1875C9.45312 7.1875 9.0625 6.79688 9.0625 6.25C9.0625 5.74219 9.45312 5.3125 10 5.3125C10.5078 5.3125 10.9375 5.74219 10.9375 6.25C10.9375 6.79688 10.5078 7.1875 10 7.1875ZM11.875 13.75C12.1875 13.75 12.5 14.0625 12.5 14.375C12.5 14.7266 12.1875 15 11.875 15H8.125C7.77344 15 7.5 14.7266 7.5 14.375C7.5 14.0625 7.77344 13.75 8.125 13.75H9.375V10H8.75C8.39844 10 8.125 9.72656 8.125 9.375C8.125 9.0625 8.39844 8.75 8.75 8.75H10C10.3125 8.75 10.625 9.0625 10.625 9.375V13.75H11.875Z",
    fill: "#0052D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSnackIcon);
export default __webpack_public_path__ + "static/media/infoSnackIcon.6fd829671841bfac1b4345494030b19d.svg";
export { ForwardRef as ReactComponent };